export default function FaqSection() {
  const faqs = [
    {
      q: '亲亲漫画网是什么类型的漫画网站？',
      a: '亲亲漫画网是一个专注于提供下拉式完整版免费漫画阅读的平台，主打无删减韩国漫画资源，同时也涵盖日本漫画、国产漫画等多种类型。所有漫画均支持下拉观看模式，流畅不卡顿，无需翻页即可连续阅读。',
    },
    {
      q: '在亲亲漫画网阅读漫画需要付费吗？',
      a: '完全不需要！亲亲漫画网所有漫画资源均为免费阅读，包括韩国恋爱漫画、奇幻冒险漫画等各类热门作品。我们致力于为漫画爱好者提供免费、无删减的完整阅读体验，没有任何隐藏收费。',
    },
    {
      q: '什么是下拉式漫画阅读？',
      a: '下拉式阅读是一种流畅的漫画观看方式，读者只需向下滑动页面即可连续阅读漫画内容，无需像传统翻页模式一样频繁点击翻页按钮。这种模式让阅读体验更加沉浸，特别适合在手机上观看长篇漫画。',
    },
    {
      q: '网站上的漫画是否有删减？',
      a: '亲亲漫画网承诺所有漫画均为无删减完整版。我们尊重创作者的原始内容和读者的阅读体验，确保您看到的每一部漫画都与原作保持一致，享受最完整的剧情体验。',
    },
    {
      q: '如何搜索我喜欢的漫画？',
      a: '您可以通过网站顶部的搜索框输入漫画名称或作者关键词来查找喜欢的作品。此外，我们还按韩国恋爱、韩国奇幻、国产恋爱等分类整理了所有漫画，方便您按类别浏览。',
    },
    {
      q: '亲亲漫画网支持手机阅读吗？',
      a: '当然支持！我们的网站采用响应式设计，完美适配手机、平板和电脑等各类设备。在手机上阅读时，下拉式体验更加流畅自然，让您随时随地畅享漫画乐趣。',
    },
    {
      q: '连载漫画多久更新一次？',
      a: '我们会密切关注各大漫画平台的更新动态，热门连载漫画通常在原版更新后24小时内同步发布。您可以关注"最新更新"板块，实时追踪喜欢的漫画更新进度。',
    },
    {
      q: '网站上的漫画可以在线收藏吗？',
      a: '我们正在开发收藏功能，届时读者可以创建个人书单，收藏喜欢的漫画作品，方便下次继续阅读。敬请期待！',
    },
  ];

  return (
    <>
      <section className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于<strong>亲亲漫画网</strong>的常见疑问解答</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, index) => (
            <details key={index} className="group bg-background-50 rounded-lg border border-background-200/70">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm font-semibold text-foreground-800 pr-4">{faq.q}</h3>
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </div>
                <div className="w-5 h-5 items-center justify-center flex-shrink-0 text-foreground-400 hidden group-open:flex">
                  <i className="ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </section>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.q,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.a,
              },
            })),
          }),
        }}
      />
    </>
  );
}